import { render, staticRenderFns } from "./NewVehicleModal.vue?vue&type=template&id=56d8a95c&"
import script from "./NewVehicleModal.vue?vue&type=script&lang=js&"
export * from "./NewVehicleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports